import styled from 'styled-components';

export const SurveyFormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  h6 {
    margin-bottom: 5px;
    text-align: left;
  }
  #comments_text_box {
    height: 200px;
    width: clamp(50%, 700px, 90%);
    margin-top: 30px;

    &.shrink {
      font-size: 25px;
    }
  }
  @media screen and (max-width: 800px) {
    padding-rigt: 20px;
    margin-bottom: 50px;
  }
  #dof + label {
    top: -20px;
    font-size: 15px;
    font-weight: bold;
    color: black;
  }
  .tb_input + label {
    color: black;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const SurveyTitle = styled.h2`
  margin: 10px 0;
`;

export const RadioButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;

  button {
    font-size: 15px;
    margin: 20px;
    line-height: 50px;
    background-color: linear-gradient(10deg, #ffff, #f40012);
    border: 1px solid black;
    font-family: apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
  }

  label {
    font-size: 20px;
    color: black;
  }
  @media screen and (max-width: 800px) {
    width: 95%;
  }
`;
